import {ApiResponse, apiClient} from "@/shared/api";
import {Chat, NewContact} from "../model";
import { useFilterStore } from "@/features/chat/model";

export const getChats = (page = 1): Promise<ApiResponse<Chat[]>> => {
  const { readed, registered } = useFilterStore.getState().getActiveFilters();

  const params = new URLSearchParams({
    page: page.toString(),
    limit: "50",
  });

  if (readed !== undefined) {
    params.append("readed", readed.toString());
  }

  if (registered !== undefined) {
    params.append("registered", registered.toString());
  }

  const queryString = params.toString();
  return apiClient(`/api/chats/?${queryString}`, "get");
};

export const getChatById = (chatId: string): Promise<ApiResponse<Chat>> => {
  return apiClient(`/api/chats/${chatId}`, "get");
};

export const createChat = (newContact: NewContact): Promise<ApiResponse<Chat>> => {
  return apiClient("/api/chats/new", "post", newContact);
};

export const deleteChat = (chatId: string): Promise<ApiResponse<undefined>> => {
  return apiClient(`/api/chats/${chatId}`, "delete");
};

export const deleteChats = (chatIds: string[]): Promise<ApiResponse<Chat[]>> => {
  const idsParam = chatIds.join(",");
  return apiClient(`/api/chats?ids=${encodeURIComponent(idsParam)}`, "delete");
};

export const updateChat = (
  chatId: string,
  name: string,
): Promise<ApiResponse<Chat>> => {
  return apiClient(`/api/chats/${chatId}`, "put", {name});
};

export const updateChatsReadStatus = (
  chatIds: string[],
  isReaded: boolean
): Promise<ApiResponse<Chat[]>> => {
  const idsParam = chatIds.join(",");
  return apiClient(`/api/chats?ids=${encodeURIComponent(idsParam)}`, "put", {
    isReaded: `${isReaded}`,
  });
};
